import React from 'react';

import { Headline, Label, Disclaimer, Button } from '../../theme';
import { Fridge } from '../../svg';
import { isMobile } from '../../util';



const FridgeSolution = () => {
  return (
    <div id="FrigiderSol" className="container__fluid page__solution">
      {
        !isMobile && (
          <div className="start snail">
            <Fridge.Snail />
          </div>
        )
      }
      <div className="w__flex w__flex-column Justify-center Justify-start__mobile solution__content">
        <Label
          marginLeft={isMobile ? false : '20vw'}
          background="#840050"
        >
          solutia tatalui
        </Label>
        {
          isMobile
            ? <Headline small >
              <p style={{ color: '#d33c64' }}>IA UN FRIGIDER NOU, CU FUNCTIA</p>
              <p style={{ color: '#d33c64' }}>ECO BUZZ! DUPA 1 MINUT TE VA </p>
              <p style={{ color: '#d33c64' }}>AVERTIZA SA INCHIZI USA. </p>
              <p style={{ color: '#d33c64' }}>REZULTAT: ALIMENTE PROASPETE</p>
              <p style={{ color: '#d33c64' }}>SI ECONOMIE LA ENERGIE.</p>
            </Headline>
            : <Headline padding="20vw" small alignLeft >
              <p style={{ color: '#d33c64' }}>IA UN FRIGIDER NOU, CU FUNCTIE</p>
              <p style={{ color: '#d33c64' }}>ECO BUZZ. TE VA AVERTIZA NEGRESIT</p>
              <p style={{ color: '#d33c64' }}>SA INCHIZI USA, DUPA UN MINUT. ASA REDUCI</p>
              <p style={{ color: '#d33c64' }}>SIMTITOR CONSUMUL DE ENERGIE SI PASTREZI</p>
              <p style={{ color: '#d33c64' }}>ALIMENTELE IN SIGURANTA.</p>
            </Headline>
        }
        <div className="w__flex Align-right w__flex-column__mobile Align-left__mobile">
          <Disclaimer
            style={{
              paddingLeft: isMobile ? '0' : '20vw'
            }}
          >
            <span>
              Comparativ cu cele din clasa energetica A, <strong>frigiderele <br className="mobile__hidden" />din clasa A++ consuma cu 43% <br className="mobile__visible" /> mai putina energie electrica.</strong>
            </span>
          </Disclaimer>
          <span>
            <Button arctic to="https://www.arctic.ro/aparate-frigorifice.html">
              <span className="mobile__hidden">Vezi</span>  produsele arctic
            </Button>
            {
              isMobile && (
                <Button enel >
                  <span className="mobile__hidden">Vezi</span>  oferta enel
                </Button>
              )
            }
          </span>
        </div>
      </div>
      <div className="end kids">
        <Fridge.Kids isMobile={!isMobile} />
      </div>
      {
        !isMobile && (
          <Button enel >
            <span className="mobile__hidden">Vezi</span>  oferta enel
          </Button>
        )
      }
    </div>
  );
};



export default FridgeSolution;


// WEBPACK FOOTER //
// ./src/components/pages/Frigider/FridgeSolution.jsx